import { render, staticRenderFns } from "./VAlertDialog.vue?vue&type=template&id=28c0a42d&scoped=true"
import script from "./VAlertDialog.vue?vue&type=script&lang=js"
export * from "./VAlertDialog.vue?vue&type=script&lang=js"
import style0 from "./VAlertDialog.vue?vue&type=style&index=0&id=28c0a42d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0a42d",
  null
  
)

export default component.exports